module.exports = __webpack_public_path__ + "img/marking_target.a724db31.png";